import React, { useEffect } from 'react'
import { navigate } from 'gatsby'
import ArticlePage from '../modules/ArticlePage/index'
import getPageLangDefinition from '@/utils/getPageLangDefinition'
import getPageLangGlossary from '@/utils/getPageLangGlossary'
import getRelatedWords from '@/utils/getRelatedWords'
import { useTranslation } from 'react-i18next'
import { glossaryLanguages } from '@/i18n/config'
import { useCookies } from 'react-cookie'
import { getBrowserPrefLang } from '../utils'
import { getLocalePath } from '../utils'

const Article = (props: any) => {
  const { definition, lang, allGlossary, categoriesMap } = props.pageContext
  const [cookies, setCookie] = useCookies(['locale'])
  const { i18n } = useTranslation()

  const definitionInPageLang = getPageLangDefinition(definition, lang)
  const allGlossaryInPageLang = getPageLangGlossary(allGlossary, lang)
  const relatedWords = getRelatedWords(
    definitionInPageLang,
    allGlossaryInPageLang,
    categoriesMap
  )

  useEffect(() => {
    let preferedLang = cookies['locale']
    const path = getLocalePath(location.pathname)
    const allAvaLangs = glossaryLanguages.map((lang) => lang.code)
    const browserLang = getBrowserPrefLang(allAvaLangs)
    if (path === 'en') {
      if (
        preferedLang &&
        (preferedLang !== 'en' || preferedLang !== 'en-US') &&
        allAvaLangs.includes(preferedLang)
      ) {
        const path = glossaryLanguages.find(
          (item) => item.code === preferedLang
        )?.path
        navigate(`/glossary${path}/${definition.slug}`)
      } else if (
        browserLang &&
        !['en', 'en-US'].includes(browserLang) &&
        allAvaLangs.includes(browserLang)
      ) {
        const path = glossaryLanguages.find(
          (item) => item.code === browserLang
        )?.path

        navigate(`/glossary${path}/${definition.slug}`)
      }
    }
  }, [cookies, definition])

  return (
    <>
      <ArticlePage
        definition={definitionInPageLang}
        relatedWords={relatedWords}
      />
    </>
  )
}

export default Article

export const Head = (props: any) => {
  const seo = {
    title:
      props.pageContext?.definition?.title ??
      'Crypto.com Glossary: Your Guide to Key Terms and Jargon in Blockchain and Cryptocurrency',
    description: props.pageContext?.definition?.title
      ? `A succinct definition of ${props.pageContext?.definition?.title}`
      : 'Your comprehensive guide to understanding cryptocurrency terms. Explore definitions and explanations of key concepts in the world of cryptocurrencies. Start exploring today!',
    image: 'https://crypto.com/images/meta-og/listing.png',
    url: `https://crypto.com/glossary/${props.pageContext.definition.slug}`,
    creator: 'Crypto.com',
  }
  return (
    <>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="image" content={seo.image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:url" content={seo.url} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />
      <meta name="twitter:creator" content={seo.creator} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:url" content={seo.url} />
      <meta property="og:type" content="website" />
      <meta property="og:description" content={seo.description} />
      <meta property="og:image" content={seo.image} />
      <meta property="og:image:alt" content={seo.description} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <link
        rel="canonical"
        href={`https://www.crypto.com/glossary/${props.pageContext?.definition?.slug}`}
      />
    </>
  )
}
